import { HONEYPOT_FIELD_NAME } from '@/lib/honeypot'

interface HoneypotFieldProps {
  register: (name: typeof HONEYPOT_FIELD_NAME) => Record<string, unknown>
}

export function HoneypotField({ register }: HoneypotFieldProps) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      }}
    >
      <label htmlFor={HONEYPOT_FIELD_NAME}>
        Ne pas remplir ce champ
      </label>
      <input
        type="text"
        id={HONEYPOT_FIELD_NAME}
        tabIndex={-1}
        autoComplete="off"
        {...register(HONEYPOT_FIELD_NAME)}
      />
    </div>
  )
}
